import { ResourceCategory } from '@core';

export const getPostSubcatPageTitle = (category: ResourceCategory, subcategory: ResourceCategory): string => {
  if (subcategory.name.toLowerCase() === 'downsizing') {
    return `${category.name}: ${subcategory.name}`;
  }
  return subcategory.name;
};

export const postCategoryRoutes = [
  {
    label: 'Caregiving 101',
    url: '/guides-and-tips/caregiving-101',
  },
  {
    label: 'Health',
    url: '/guides-and-tips/health',
  },
  {
    label: 'Quick Tips',
    url: '/guides-and-tips/quick-tips',
  },
  {
    label: 'Care Support',
    url: '/guides-and-tips/care-support',
  },
  {
    label: 'Housing',
    url: '/guides-and-tips/housing',
  },
  {
    label: 'End of Care',
    url: '/guides-and-tips/end-of-care',
  },
  {
    label: 'Finance',
    url: '/guides-and-tips/finance',
  },
  {
    label: 'Legal',
    url: '/guides-and-tips/legal',
  },
];
